import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Shell from "@/pages/Shell";
import ModeSelect from "@/pages/ModeSelect";
import CrawlerDashboard from "@/pages/CrawlerDashboard";
import HefteHeute from "@/pages/HefteHeute";
import QK from "@/pages/QK";
import Protokoll from "@/pages/Protokoll";

function AppRouter() {
  const location = useLocation();
  // Handle OAuth callback BEFORE any protected routing runs.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedRoute><Shell /></ProtectedRoute>}>
        <Route path="/" element={<ModeSelect />} />
        <Route path="/dashboard" element={<CrawlerDashboard />} />
        <Route path="/hefte" element={<HefteHeute />} />
        <Route path="/ok" element={<QK />} />
        <Route path="/protokoll" element={<Protokoll />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </BrowserRouter>
  );
}
